export default __webpack_public_path__ + "pypi/streamlit-1.40.1-cp312-none-any.whl";